import {Component, Injectable} from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    styles: [require('../shared/section/section.component.scss'), require('./professional-liability-page.component.scss')]
})
@Injectable()
export class ProfessionalLiabilityPageComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/professional-liability-page.component.ts